module.exports = __webpack_public_path__ + "static/logo-e60c1882912448fbcef6ff7a72f916ae.svg";